import styled from 'styled-components';
import { breakpoint, Carousel } from '@carvana/helios-layout';
import { background, heading, text } from '@carvana/helios-styles';

const AppraisalListContainer = styled.div`
  position: relative;
  display: block;
  width: 100%;
  z-index: 1;
`;

const Heading = styled.span`
  z-index: 20;
  ${heading['2Xl']};
  color: ${text.strong};
  display: none;

  ${breakpoint.sm`
    display: block;
    padding-left: 32px;
  `}

  ${breakpoint.md`
    padding-left: 0;
  `}
`;

const StyledCarousel = styled(Carousel)`
  background: ${background.default};
  padding: 12px 0;
  & > * div[role="group"]:first-of-type {
    padding-inline-start: 24px;
  }
  & > * div[role="group"]:last-of-type {
    padding-right: 24px;
  }
  ${breakpoint.sm`
    padding-top: 40px;
    padding-bottom: 0;
    & > * div[role="group"]:first-of-type {
      padding-inline-start: 32px;
    }
    & > * div[role="group"]:last-of-type {
      padding-right: 32px;
    }
  `}

  ${breakpoint.md`
    padding: 40px 84px 0 84px;
    & > * div[role="group"]:first-of-type {
      padding-inline-start: 0;
    }
    & > * div[role="group"]:last-of-type {
      padding-right: 0;
    }
  `}
`;

export { AppraisalListContainer, Heading, StyledCarousel };
